import { makeStyles } from '@fluentui/react-components';
import { ReactNode } from 'react';

import { palette, tokens } from '../../theme';

export type SectionLabelProps = {
    text: string;
    trailing?: ReactNode;
};

export const SectionLabel: React.FC<SectionLabelProps> = ({ text, trailing }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <span className={classes.label}>{text.toUpperCase()}</span>
            {trailing && <span className={classes.trailing}>{trailing}</span>}
        </div>
    );
};

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: tokens.spacingVerticalS,
    },
    label: {
        fontSize: '11px',
        fontWeight: tokens.fontWeightSemibold,
        color: palette.dimText,
    },
    trailing: {
        display: 'inline-flex',
        alignItems: 'center',
    },
});
